export default "__VITE_ASSET__CRw8sTKX__"